import leftArrow from 'public/static/images/vdp/left-arrow-circle.svg';
import leftArrowHover from 'public/static/images/vdp/left-arrow-circle-disabled.svg';
import rightArrow from 'public/static/images/vdp/right-arrow-circle.svg';
import rightArrowHover from 'public/static/images/vdp/right-arrow-circle-disabled.svg';
import { screen } from 'components/styles/variables';

export default `
  .left-carousel-button {
    background-image: ${`url(${leftArrow})`};
    position: absolute;
    left: -15px;
  }
  .left-carousel-button:hover {
    background-image: ${`url(${leftArrowHover})`};
  }
  .right-carousel-button {
    background-image: ${`url(${rightArrow})`};
    position: absolute;
    right: -15px;
  }
  .right-carousel-button:hover {
    background-image: ${`url(${rightArrowHover})`};
  }
  .right-carousel-button,
  .left-carousel-button {
    height: 66px;
    width: 66px;
    background-position-x: center;
    background-position-y: 6px;
    cursor: pointer;
    bottom: -100px;
    display: none;
  }
  @media (min-width: ${screen.smMin}) {
    .right-carousel-button,
    .left-carousel-button {
      display: block;
    }
  }
  @media (min-width: ${screen.smMin}) and (max-width: ${screen.smMax}) {
    .right-carousel-button,
    .left-carousel-button {
      bottom: -20px;
    }
  }
  @media (min-width: ${screen.mdMin}) and (max-width: ${screen.mdMax}) {
    .right-carousel-button,
    .left-carousel-button {
      bottom: -150px;
    }
  }
  @media (min-width: ${screen.lgMin}) {
    .right-carousel-button,
    .left-carousel-button {
      bottom: -100px;
    }
  }
`;
